export class ScreenOrientationService {
    constructor() {
        this.subs = new Set();
        this.angle = 0;
        this.watchOrientation();
    }
    subscribe(sub) {
        if (!this.subs.has(sub)) {
            this.subs.add(sub);
            sub(this.angle);
        }
        return () => this.subs.delete(sub);
    }
    watchOrientation() {
        if ('orientation' in window.screen) {
            window.screen.orientation.addEventListener('change', () => {
                this.updateAngle(window.screen.orientation.angle);
            });
            return;
        }
        if ('onorientationchange' in window) {
            window.addEventListener('orientationchange', () => {
                let angle = window.orientation;
                if (angle === -90) {
                    angle = 270;
                }
                this.updateAngle(angle);
            });
            return;
        }
        console.warn('No es posible obtener la orientación del dispositivo.');
    }
    updateAngle(angle) {
        this.angle = angle;
        this.subs.forEach(sub => sub(this.angle));
    }
}
